import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'CR' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'CR', label: 'CR Energy', pane: 'sub', params: [26, 10, 20, 40, 60], outputs: ['cr', 'ma1', 'ma2', 'ma3', 'ma4'] })
